import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { initializeSocket } from './lib/realtime';
import { useAuthStore } from './store/authStore';

// Check if we're running in Electron
const isElectron = window.api !== undefined;

// Handle OIDC callback (redirect lands on /auth/callback?code=xxx before HashRouter)
const url = new URL(window.location.href);
const isOIDCCallback = url.pathname === '/auth/callback';
const cleanInviteMatch = url.pathname.match(/^\/invite\/([a-zA-Z0-9_-]+)\/?$/);

if (isOIDCCallback) {
  const code = url.searchParams.get('code');
  const state = url.searchParams.get('state');

  if (code && state) {
    // Clean the URL immediately so HashRouter doesn't see /auth/callback
    window.history.replaceState({}, '', '/');

    // Process the callback (stores tokens, sets user state) — no page reload needed
    useAuthStore
      .getState()
      .handleOIDCCallback(code, state)
      .catch((err) => {
        console.error('OIDC callback failed:', err);
      });
  }
} else if (cleanInviteMatch?.[1]) {
  window.history.replaceState({}, '', `/#/invite/${cleanInviteMatch[1]}`);
} else {
  // Initialize socket if access token exists (normal app load)
  if (localStorage.getItem('access_token')) {
    const socket = initializeSocket();
    if (socket) {
      console.log('Socket initialized in main.tsx');
    }
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>
);

console.log(`App running in ${isElectron ? 'Electron' : 'browser'} environment`);
